export enum ProductType {
  New = 'New',
  Used = 'Used',
  Conditional = 'Conditional',
}
